import { useNotification } from 'hooks/ui/useNotification';
import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';

function useReassignOrDeletePendingAdvised() {
  const notification = useNotification();

  const baseOptions = useHandleTrpcMutation<{
    updatedCount: number;
  }>()({
    successMessage: undefined,
  });

  return api.incompleteInvestment.reassignOrDeletePendingAdvised.useMutation({
    ...baseOptions,
    onSuccess: async (data, variables) => {
      if (variables.targetFundId) {
        notification.success(
          `${data.updatedCount} pending application(s) reassigned successfully.`,
        );
      } else {
        notification.success(
          `${data.updatedCount} pending application(s) deleted successfully.`,
        );
      }
    },
  });
}

export default useReassignOrDeletePendingAdvised;
